// Module
var code = "<template> <ess-button click.delegate=\"open()\">${'ui:actions.launch' | what: 'ext:iccc.$long'}</ess-button> </template> ";
// Exports
module.exports = code;